import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createInterimAwardsAPI,
  updateInterimAwardsAPI,
  getInterimAwardsByCaseIDAPI,
  deleteInterimAwardsAPI,
} from "../../../api/InterimAwards_api";

export const getInterimAwardsByCaseIDAction = createAsyncThunk(
  "interimAwards/getInterimAwardsByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getInterimAwardsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createInterimAwardsAction = createAsyncThunk(
  "interimAwards/createInterimAwards",
  async (interimAwardsData, { rejectWithValue }) => {
    const response = await createInterimAwardsAPI(interimAwardsData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateInterimAwardsAction = createAsyncThunk(
  "interimAwards/updateInterimAwards",
  async ({ interimAwards_ID, interimAwardsData }, { rejectWithValue }) => {
    const response = await updateInterimAwardsAPI(
      interimAwards_ID,
      interimAwardsData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteInterimAwardsAction = createAsyncThunk(
  "interimAwards/deleteInterimAwards",
  async (interimAwards_ID, { rejectWithValue }) => {
    const response = await deleteInterimAwardsAPI(interimAwards_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
